'use client';

import { useRef, useEffect, useCallback, useState } from 'react';
import gsap from 'gsap';
import './BlobCursor.css';

export default function BlobCursor({
                                       blobType = 'circle',
                                       trailCount = 3,
                                       sizes = [50, 90, 70],
                                       opacities = [0.6, 0.4, 0.3],
                                       fastDuration = 0.1,
                                       slowDuration = 0.5,
                                       fastEase = 'power3.out',
                                       slowEase = 'power1.out',
                                   }) {
    const containerRef = useRef(null);
    const blobsRef = useRef([]);
    const [isVisible, setIsVisible] = useState(false);

    const handleMove = useCallback(
        e => {
            const x = e.clientX;
            const y = e.clientY;

            // Show blobs on first mouse move
            if (!isVisible) {
                setIsVisible(true);
            }

            blobsRef.current.forEach((el, i) => {
                if (!el) return;
                const isLead = i === 0;
                gsap.to(el, {
                    x: x,
                    y: y,
                    duration: isLead ? fastDuration : slowDuration,
                    ease: isLead ? fastEase : slowEase
                });
            });
        },
        [fastDuration, slowDuration, fastEase, slowEase, isVisible]
    );

    useEffect(() => {
        const handleMouseMove = (e) => handleMove(e);
        const handleTouchMove = (e) => {
            if (e.touches[0]) {
                handleMove({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY });
            }
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('touchmove', handleTouchMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, [handleMove]);

    return (
        <div
            ref={containerRef}
            className="blob-container"
            style={{ opacity: isVisible ? 1 : 0 }}
        >
            <div className="blob-main">
                {Array.from({ length: trailCount }).map((_, i) => (
                    <div
                        key={i}
                        ref={el => (blobsRef.current[i] = el)}
                        className="blob glass-blob"
                        style={{
                            width: sizes[i],
                            height: sizes[i],
                            borderRadius: blobType === 'circle' ? '50%' : '0%',
                            opacity: opacities[i],
                        }}
                    />
                ))}
            </div>
        </div>
    );
}